import qrCode from './QR/bch.png'

const address = '1F67ofBSixvPt9A5kcGKSnk4ZGYXpUSwmk'

export default { qrCode, address }